import { useQuery } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { queryKeys } from './queryKeys';
import { AgreementDTO, AssumptionsDTO } from '../../FirmSettings/api/useFirmSettingsQuery';

export interface PortfolioGroupDTO {
  id: string;
  name: string;
}

export interface MySettingsDTO {
  agreements: AgreementDTO[];
  allowAdvisersOverrideAgreements: boolean;
  adviserAssumptions: AssumptionsDTO;
  adviserCustomDisclosures: string | null;
  adviserFirmLogoFilename: string | null;
  adviserImageFilename: string | null;
  allowAdvisersCustomTermsAndConditions: boolean;
  allowAdvisersOverrideFirmLogo: boolean;
  assumeCurrentTaxRateProvisionsExpire: boolean;
  assumptionsEditableByAdviser: boolean;
  calendarUrl: string | null;
  customDisclosuresEditableByAdviser: boolean;
  customFirmUrl: string;
  customSignature: string | null;
  customTermsAndConditions: string | null;
  defaultPortfolioGroupId: string | null;
  email: string | null;
  firmAssumptions: AssumptionsDTO;
  showCmaCustomAssumptions: boolean;
  firstName: string | null;
  lastName: string | null;
  phoneNumber: string | null;
  portfolioGroups: PortfolioGroupDTO[];
  is3dRiskToleranceWorkflowEnabled: boolean;
  allowAssetBucketingFirm: boolean;
  allowAssetBucketingAdviser: boolean;
  allowAdviserOverrideAddManualAccount: boolean;
  allowAddManualAccount: boolean;
  allowBeFi20Adviser: boolean;
  allowBeFi20Firm: boolean;
  allowAdviserToOverrideClientAssetBucketingCustomization: boolean;
  allowClientToCustomizeAssetAssignmentAcrossBuckets: boolean;
  allowPulseCheckAdviser: boolean;
  allowPulseCheckFirm: boolean;
  allowMobileAppPushNotifications: boolean;
  defaultDocumentUploadMobilePushNotifications: boolean;
  allowMobileAppPushNotificationsFirm: boolean;
  hasDocumentVaultFirm: boolean;
  emailDocumentNotificationsAsOwner: boolean;
  emailDocumentNotificationsAsAdvisor: boolean;
}

const fetchMySettings = (): Promise<MySettingsDTO> => {
  return authFetch('/Adviser/Settings/My');
};

export const useMySettingsQuery = () => {
  return useQuery(
    queryKeys.mySettings(),

    () => fetchMySettings(),

    {
      cacheTime: 0,
    },
  );
};
